const Title = ({children}) =>
    <h1 className="text-2xl text-gray-800 mb-4">
        <span className="bg-yellow-400 py-2 px-4 inline-block">
            {children}
        </span>
    </h1>

export default Title